import { useI18n } from "vue-i18n"

export function event_start_day (date: string) {
  return new Date(date).getDate()
}

export function event_end_day (date: string) {
  return new Date(date).getDate()
}

export function event_month (date: string) {
  return capitalize(new Date(date).toLocaleString(useI18n().locale.value, { month: 'long' }))
}

export function event_year (date: string) {
  return new Date(date).getFullYear()
}

function capitalize (str: string) {
  return str.replace(/^./, (char) => char.toUpperCase())
}